import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-texth",
  "use": "icon-th-texth-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-texth\">\n<path d=\"M26 7V25C26 25.2652 25.8946 25.5196 25.7071 25.7071C25.5196 25.8946 25.2652 26 25 26C24.7348 26 24.4804 25.8946 24.2929 25.7071C24.1054 25.5196 24 25.2652 24 25V17H8V25C8 25.2652 7.89464 25.5196 7.70711 25.7071C7.51957 25.8946 7.26522 26 7 26C6.73478 26 6.48043 25.8946 6.29289 25.7071C6.10536 25.5196 6 25.2652 6 25V7C6 6.73478 6.10536 6.48043 6.29289 6.29289C6.48043 6.10536 6.73478 6 7 6C7.26522 6 7.51957 6.10536 7.70711 6.29289C7.89464 6.48043 8 6.73478 8 7V15H24V7C24 6.73478 24.1054 6.48043 24.2929 6.29289C24.4804 6.10536 24.7348 6 25 6C25.2652 6 25.5196 6.10536 25.7071 6.29289C25.8946 6.48043 26 6.73478 26 7Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-texth.svg
// module id = XH+1
// module chunks = 84